module.exports = __webpack_public_path__ + "img/mark-guide.98202d18.png";